import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useGuestMode } from '../../context/GuestModeContext';
import { clearGuestDesign } from '../../utils/guestDesign';
import ShareButton from '../ShareButton';
import './Header.css';

// The editor's top bar, shared by every phase — the 2D builder, the floor plan
// and both 3D views.
//
// NO LANGUAGE SWITCHER. It used to sit at the right-hand end and was the only
// thing in this bar that had nothing to do with the design on screen: three
// buttons of chrome, permanently, on the one screen where the canvas is the
// point. Switching language is still there for anyone who wants it — in the
// user menu on every other page, and on the landing and auth screens — and it
// is not something people change mid-edit.
//
// `projectName` is passed in rather than looked up: it labels the share card,
// and the only place it lives is the project document the editor has already
// fetched (see App.jsx).
export default function Header({ projectName = '' }) {
  const { user } = useAuth();
  const isGuest = useGuestMode();
  const navigate  = useNavigate();
  const { projectId } = useParams();

  function handleLogoClick() {
    // Leaving the trial for the landing page, not just switching phases
    // inside it — drop the abandoned guest snapshot (see guestDesign.js).
    if (isGuest) clearGuestDesign();
    navigate(user ? '/dashboard' : '/');
  }

  return (
    <header className="app-header">
      <div className="app-header-logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
        <img
          src="/images/Tunify Original logo tab.png"
          alt="Tunify"
          className="app-header-logo-img"
        />
        <span className="app-header-brand">Tunify</span>
      </div>

      <div className="app-header-right">
        {/* Share the whole project — visible on every screen while editing a
            saved cloud project (not in the guest /try flow). */}
        {!isGuest && <ShareButton projectId={projectId} projectName={projectName} user={user} />}
      </div>
    </header>
  );
}
